/**
 * components/icons/TikTokIcon.jsx
 * ─────────────────────────────────────────────────────────────────────────────
 * The TikTok mark, as an inline SVG.
 *
 * Every other social icon in the footer comes from @material-ui/icons, but
 * Material Design has never shipped a TikTok glyph and never will: the set is
 * Google's own iconography, and third-party brand marks were removed from it
 * years ago. Pulling in a whole icon package for one glyph, or loading it from
 * a CDN, would both cost more than the fourteen path commands below.
 *
 * The API deliberately mirrors a Material UI icon so the footer can treat it
 * like its neighbours: it takes `className` and paints with `currentColor`, so
 * the existing `.icon` rule keeps every mark the same size, colour and hover
 * behaviour. Nothing about the footer's styling has to know this one is
 * different.
 *
 * `viewBox` is 24x24 to match the Material grid, and the path is the official
 * brand outline. Do not restyle the mark itself: TikTok's brand guidelines
 * allow recolouring to a single flat colour, which is exactly what
 * `currentColor` does, but not redrawing it.
 */
const TikTokIcon = ({ className, title = "TikTok" }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    fill="currentColor"
    focusable="false"
    aria-hidden={title ? undefined : "true"}
    role={title ? "img" : undefined}
    style={{ display: "block" }}
  >
    {title ? <title>{title}</title> : null}
    <path d="M16.6 5.82A4.28 4.28 0 0 1 15.54 3h-3.09v12.4a2.59 2.59 0 0 1-2.59 2.5 2.59 2.59 0 0 1 0-5.18c.27 0 .53.04.77.12v-3.2a5.9 5.9 0 0 0-.77-.05 5.72 5.72 0 1 0 5.72 5.72V9.01a7.35 7.35 0 0 0 4.29 1.37V7.3a4.29 4.29 0 0 1-3.27-1.48z" />
  </svg>
);

export default TikTokIcon;
